import React, { FC } from "react";
import { PushNotificationSubscriptionList } from "./PushNotificationSubscriptionList";
import { Button, Stack } from "@mui/material";
import { usePushNotification } from "./usePushNotification";
import { WebSubscriptionDto } from "./WebSubscription";

export const PushNotificationSubscriptionManagement: FC = () => {
  const webPushNotification = usePushNotification();

  const handleSubscribeClick = async () => {
    const subscription = await webPushNotification.subscribeWeb();
    console.log("Subscription: ", subscription);
  };
  const handleUnsubscribe = (subscrption: WebSubscriptionDto) => {
    webPushNotification.unsubscribe(subscrption.id);
  };

  return (
    <Stack>
      <Button onClick={handleSubscribeClick}>Subscribe</Button>
      <PushNotificationSubscriptionList onUnsubscribe={handleUnsubscribe} />
    </Stack>
  );
};
